import Filter from '../../../app/main/filter';
import TotalTickets from '../../../app/main/mesa_servicio/total_tickets';

const Index = () => {
  return (
    <>
      <div className="flex mb-4">
        <div className="w-full">
          <TotalTickets />
        </div>
      </div>
    </>
  );
};

export default Index;
